var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-fade"}},[_c('div',{staticClass:"box fade-in-box",class:{ 'fixed-box': _vm.fixed },style:({ width: _vm.width })},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }